<template>
  <div class="form-item">
    <label class="form-label" :for="inputId">{{label}}</label>
    <input
        :type="type"
        :value="value"
        :id="inputId"
        :placeholder="placeholderText"
        :disabled="disabled"
        @input="$emit('input', $event.target.value)"
        class="form-control"
    />
  </div>
</template>

<script>
  export default {
    name: 'FormInputText',

    props: {
      value: [String, Number],
      label: String,
      placeholder: String,
      id: String,
      type: {
        type: String,
        default: 'text',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      inputId() {
        return `custom-field-editor-${this.id || this.label.toLowerCase()}`;
      },
      placeholderText() {
        return this.placeholder || this.label;
      },
    },
  };

</script>
